import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remito',
  templateUrl: './remito.component.html',
  styleUrls: ['./remito.component.css']
})
export class RemitoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
